export default __webpack_public_path__ + "static/char-s-03-chs-dc66b425dd6b013c23108671c7b51936.png";